import Vue from 'vue'

export const snippets = {
    state: {
        status: 'idle',
        snippets: {}
    },
    mutations: {
        SET_SNIPPETS_STATUS(state, payload) {
            state.status = payload
        },
        SET_SNIPPETS(state, payload) {
            Vue.set(state.snippets, payload.code, payload.data)
        }
    },
    actions: {
        async snippetsFetch({ commit }, payload) {
            const code = payload.code
            const cacheKey = `snippets:${code}`
            const cacheDuration = 2 * 60 * 60 * 1000 // 2 hours
            const now = Date.now()

            const cached = await this.$storage.getItem(cacheKey)

            // save snippet data to cache and commit
            const cacheAndCommit = async (data) => {
                const value = { timestamp: now, data }
                await this.$storage.setItem(cacheKey, value)

                if (data && data.length > 0) {
                    commit('SET_SNIPPETS', { data, code })
                }

                return { data: { data } }
            }

            // check if cached snippet exists and not expired
            if (cached && now - cached.timestamp < cacheDuration) {
                if (cached.data && cached.data.length > 0) {
                    commit('SET_SNIPPETS', { data: cached.data, code })
                }
                return { data: { data: cached.data } }
            }

            try {
                const response = await this.$api(`dashboard/snippets/content/${code}`)
                const snippetData = response?.data?.data || []

                return await cacheAndCommit(snippetData)
            } catch (error) {
                const isNotFound =
                    error?.response?.data?.errors?.errors?.some(e => e.code === 'ENTITY_NOT_FOUND')

                if (isNotFound) {
                    return await cacheAndCommit([])
                }
            }
        },
        async snippetsLoad({ commit, dispatch }, payload) {
            commit('SET_SNIPPETS_STATUS', 'loading')
            try {
                const snippets = await dispatch('snippetsFetch', payload)
                if (snippets?.data?.data) {
                    commit(
                        `SET_${payload.moduleName.toUpperCase()}_SNIPPETS`,
                        snippets.data.data
                    )
                }
            } catch (error) {
                console.log(error)
            } finally {
                commit('SET_SNIPPETS_STATUS', 'idle')
            }
        }
    },
    getters: {
        getSnippets: state => state.snippets,
        getSnippet: state => code => state.snippets[code]
    }
}
